import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AriaLiveContext from "./AriaLiveContext";
import AriaLive from "./AriaLive";

const propTypes = {
    children: PropTypes.element.isRequired,
	numberAssertiveDivs: PropTypes.number,
	numberPoliteDivs: PropTypes.number,
};
const defaultProps = {
	numberAssertiveDivs: 2,
	numberPoliteDivs: 2,
};

const AriaLiveContextProvider = ({ children, numberAssertiveDivs, numberPoliteDivs }) => {
    const [ariaLiveAssertiveMessages, setAriaLiveAssertiveMessages] = useState([]);
    const [ariaLivePoliteMessages, setAriaLivePoliteMessages] = useState([]);

    return (
        <AriaLiveContext.Provider value={{
            ariaLiveAssertiveMessages,
            addAriaLiveAssertiveMessage: message => {
                const t = setTimeout(() => {
                    setAriaLiveAssertiveMessages(oldMessages => oldMessages.concat(message));
                    clearTimeout(t);
                }, 100)
            },

            ariaLivePoliteMessages,
            addAriaLivePoliteMessage: message => {
                const t = setTimeout(() => {
                    setAriaLivePoliteMessages(oldMessages => oldMessages.concat(message));
                    clearTimeout(t);
                }, 100)
            },

            setAriaLiveAssertiveMessages,
            setAriaLivePoliteMessages,
        }}>
            {children}
            <AriaLive numberAssertiveDivs={numberAssertiveDivs} numberPoliteDivs={numberPoliteDivs} />
        </AriaLiveContext.Provider>
    );
};

AriaLiveContextProvider.propTypes = propTypes;
AriaLiveContextProvider.defaultProps = defaultProps;

export default AriaLiveContextProvider;
